'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _common = require('./common');

exports.default = function (length) {
  return (0, _common.withParams)({ type: 'minLength', min: length }, function (value) {
    return !(0, _common.req)(value) || (0, _common.len)(value) >= length;
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelidate/lib/validators/minLength.js
// module id = 4ypF
// module chunks = 0 69 70 71 72 73 74 75 76 77 81 82 83 85 86 87 88 90 91 92